import { jsxs as s, jsx as r } from "react/jsx-runtime";
import { Icon as u } from "../../icon/icon.js";
import "react";
import { Text as d } from "../../text/text.js";
import l from "clsx";
import { b as n } from "../../../virginmediao2-momentum-icons-icons-far-BWte5zss.js";
import { FormItemError as p } from "../form-item/form-item-error.js";
import { s as e } from "../../../form-radio-group.module-m2XJo4vY.js";
const F = ({
  id: m,
  label: t,
  description: i = "",
  error: a,
  className: c,
  children: f
}) => {
  const o = `form-multi-item-label-${m}`;
  return /* @__PURE__ */ s(
    "div",
    {
      "data-testid": `form-multi-item-${m}`,
      className: l(e["form-multi-item"], c),
      role: "group",
      "aria-labelledby": t ? o : void 0,
      "aria-label": !t && i ? i : void 0,
      children: [
        t && /* @__PURE__ */ r(
          "div",
          {
            id: o,
            "data-testid": o,
            className: l(e["form-multi-item__label"]),
            children: /* @__PURE__ */ r(d, { size: "T300", weight: "regular", color: "default", children: t })
          }
        ),
        i && /* @__PURE__ */ r(
          "div",
          {
            "data-testid": `form-multi-item-description-${m}`,
            className: "form-multi-item__description",
            children: /* @__PURE__ */ r(d, { size: "T300", weight: "regular", color: "default", children: i })
          }
        ),
        /* @__PURE__ */ r(
          "div",
          {
            "data-testid": `form-multi-item-controls-${m}`,
            className: l(e["form-multi-item__controls"]),
            children: f
          }
        ),
        a && /* @__PURE__ */ s(
          p,
          {
            id: `form-item-error-${m}`,
            "data-testid": `form-item-error-${m}`,
            children: [
              /* @__PURE__ */ r(u, { icon: n }),
              /* @__PURE__ */ r("div", { className: e["form-item__error-message"], children: /* @__PURE__ */ r("p", { children: a }) })
            ]
          }
        )
      ]
    }
  );
};
export {
  F as FormRadioGroup
};
